import memoize from 'lodash/memoize';
import personnummer from 'personnummer';
import { numbersSpacesAndDashes } from '../validators';

const validateLength = memoize(
  (reference, message = ((v, r) => `Fältet ska bestå av ${r} tecken`)) =>
    (value) => {
      if (!value) {
        return undefined;
      }
      return (value.replace(/-*\s*/g, '').length === reference) ? undefined : message(value, reference);
    },
);

const validateSocialSecurityNumber = memoize(
  (reference, message = (v => `${v} är inget giltigt personnummer`)) =>
    (value) => {
      if (!value || personnummer.valid(value)) {
        return undefined;
      }
      return message(value, reference);
    },
);

export default [
  numbersSpacesAndDashes(),
  validateLength(12, () => 'Personnumret ska anges med 12 siffror (ÅÅÅÅMMDD-XXXX).'),
  validateSocialSecurityNumber(),
];
